import { render, staticRenderFns } from "./listDialogmul.vue?vue&type=template&id=4b747bf4&scoped=true"
import script from "./listDialogmul.vue?vue&type=script&lang=js"
export * from "./listDialogmul.vue?vue&type=script&lang=js"
import style0 from "./listDialogmul.vue?vue&type=style&index=0&id=4b747bf4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b747bf4",
  null
  
)

export default component.exports